import getImagePath from "shared/util/getImagePath";

function getPlaceholderImageUrl() {
	return `${getImagePath()}media/img/user/placeholder_2013/pq_400.png`;
}

export default getPlaceholderImageUrl;



// WEBPACK FOOTER //
// ./src/shared/util/getPlaceholderImageUrl.js